import api from './api'

export async function fetchChatContext() {
  const { data } = await api.get('/chat/context')
  return data
}

export async function fetchRoomMessages(roomId, limit = 100) {
  const { data } = await api.get(`/chat/messages/${roomId}`, {
    params: { limit }
  })
  return data
}

export async function createPrivateRoom(payload) {
  const { data } = await api.post('/chat/rooms/private', payload)
  return data
}

export async function joinCustomRoom(roomId, payload = {}) {
  const { data } = await api.post(`/chat/rooms/${roomId}/join`, payload)
  return data
}

export async function deletePrivateRoom(roomId) {
  const { data } = await api.delete(`/chat/rooms/${roomId}`)
  return data
}

export async function openDirectConversation(userId) {
  const { data } = await api.post('/chat/direct', { userId })
  return data
}

export function getWebSocketUrl(token) {
  const isLocal = window.location.hostname === 'localhost'

  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws'

  const host = isLocal
    ? 'localhost:4000'
    : window.location.host

  const base = `${protocol}://${host}/ws/chat`

  return `${base}?token=${encodeURIComponent(token)}`
}


